import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { CustomLink } from 'ziphy-web-shared/basic/lib/buttons';
import { Tooltip } from 'ziphy-web-shared/basic/lib/utilities';
import styles from './Card.module.scss';
const Card = forwardRef(({ autoTarget, children, date, data, cardData, colors, mode, title, subTitle, showTooltip, tooltipAdditional, className, }, ref) => {
    if (colors) {
        cardData.cardStyles.backgroundColor = colors.bg;
        cardData.cardStyles.borderColor = colors.bg;
    }
    function getDefaultTitle() {
        const time = [
            cardData.prevDuration,
            cardData.duration,
            cardData.nextDuration, //
        ]
            .filter((x) => x)
            .join(' + ');
        return `${cardData.beginTime} (${time}) `;
    }
    function getSmallTitle() {
        return cardData.duration;
    }
    function getSubTitle() {
        return subTitle;
    }
    function RenderContent() {
        return (_jsxs(_Fragment, { children: [title !== false && (_jsx("div", Object.assign({ className: classNames(styles.title, mode === 'small' && styles.noTrim), style: { color: colors === null || colors === void 0 ? void 0 : colors.title } }, { children: title || (mode === 'small' ? getSmallTitle() : getDefaultTitle()) }))), subTitle !== false && mode !== 'small' && (_jsx("div", Object.assign({ className: styles.subtitle, style: {
                        color: (colors === null || colors === void 0 ? void 0 : colors.subtitle) || (colors === null || colors === void 0 ? void 0 : colors.title),
                        WebkitLineClamp: Math.max(data.height - 1, 1),
                    } }, { children: getSubTitle() }))), children] }));
    }
    return (_jsx(CustomLink, Object.assign({ ref: ref, autoTarget: autoTarget, className: classNames(styles.card, className), style: cardData.cardStyles }, { children: showTooltip ? (_jsx(Tooltip, Object.assign({ className: styles.tooltipWrapper, content: _jsxs("div", Object.assign({ className: styles.tooltip }, { children: [_jsx("div", Object.assign({ className: styles.tooltipTitle }, { children: getDefaultTitle() })), getSubTitle(), tooltipAdditional && (_jsx("div", Object.assign({ className: styles.tooltipAdditional }, { children: tooltipAdditional })))] })) }, { children: _jsx(RenderContent, {}) }))) : (_jsx(RenderContent, {})) })));
});
export default observer(Card);
